module.exports = __webpack_public_path__ + "img/chevron-down-black.04e01ec.svg";